import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';

@Component({
  selector: 'app-config-suprimentos',
  standalone: true,
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    HeaderComponent,
    EmptyListComponent,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './config-suprimentos.component.html',
  styleUrls: ['./config-suprimentos.component.css'],
})
export class ConfigSuprimentosComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Suprimentos;

  public menuGroups = [
    {
      title: 'Suprimentos',
      items: [
        { label: 'Configurações de estoque', route: 'config-estoque', icon: 'inventory_2' },
        { label: 'Localizações de estoque', route: 'localizacao-estoque', icon: 'warehouse' },
        { label: 'Tags de produção', route: 'tags-producao', icon: 'factory' },
        { label: 'Tags de serviços tomados', route: 'tags-servico-tomado', icon: 'build' },
        { label: 'Tags de notas fiscais de entrada', route: 'tags-nfe-entrada', icon: 'description' },
        { label: 'Fórmulas de custo e preço de venda', route: 'formulas-custo-venda', icon: 'calculate' },
        { label: 'FCI - Ficha de Conteúdo de Importação', route: 'config-fci', icon: 'description' },
      ],
    },
    {
      title: 'Compras',
      items: [
        { label: 'Configuração do Kanban de Compras', route: 'config-kanban-compras', icon: 'view_kanban' },
        { label: 'Automações', route: 'automacoes', icon: 'automation' },
        { label: 'Comunicação de cotação', route: 'comunicacao-cotacao', icon: 'forward_to_inbox' },
        { label: 'Comunicação de pedido', route: 'comunicacao-pedido', icon: 'local_shipping' },
        { label: 'Tags de compra', route: 'tags-compra', icon: 'shopping_cart' },
      ],
    },
  ];

  public filteredMenuGroups = [...this.menuGroups];
  public pesquisaControl = new FormControl('');

  ngOnInit(): void {
    this.pesquisaControl.valueChanges.subscribe(() => {
      this.filtrar();
    });
    this.filtrar();
  }

  public filtrar(): void {
    const termo = this.removeAcentos(this.pesquisaControl.value?.toLowerCase() || '');
    if (!termo) {
      this.filteredMenuGroups = [...this.menuGroups];
      return;
    }

    this.filteredMenuGroups = this.menuGroups
      .map(group => ({
        ...group,
        items: group.items.filter(item => this.removeAcentos(item.label.toLowerCase()).includes(termo)),
      }))
      .filter(group => group.items.length > 0);
  }

  private removeAcentos(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
